'use client';

import { CookieBanner, CookiePreferencesModal } from '@mihilista/cookie-consent';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

export default function CookieBannerAndModal() {
    const t = useTranslations('cookies');

    const bannerLocale = {
        title: t('banner.title'),
        body: t.rich('banner.body', {
            policy: (chunks) => (
                <Link href="/legal/privacy-policy" target="_blank" className="underline">
                    {chunks}
                </Link>
            ),
        }),
        buttons: {
            manage: t('banner.buttons.manage'),
            accept: t('banner.buttons.accept'),
            reject: t('banner.buttons.reject'),
        },
    };

    return (
        <>
            <CookieBanner locale={bannerLocale} />
            <CookiePreferencesModal locale={t.raw('modal')} />
        </>
    );
}
